import React from 'react';
import PropTypes from 'prop-types';
import MapNoteStatusFilter from './MapNoteStatusFilter.jsx';
import MapNoteTypeFilter from './MapNoteTypeFilter.jsx';
import s from './MapNoteFilter.module.scss';

const MapNoteFilterMenu = props => (
    <div className={s.menu}>
        <div className={s.sectionLabel}>Showing</div>
        <form className={s.section}>
            <MapNoteStatusFilter label="Open" selected={props.status === 'open'} amount={props.totals.open} onClick={() => props.onStatusClick('open')} />
            <MapNoteStatusFilter label="Resolved" selected={props.status === 'resolved'} amount={props.totals.resolved} onClick={() => props.onStatusClick('resolved')} />
            <MapNoteStatusFilter label="All" selected={props.status === 'all'} amount={props.totals.open + props.totals.resolved} onClick={() => props.onStatusClick('all')} />
        </form>
        <div className={s.sectionLabel}>Type</div>
        <div className={s.section}>
            <MapNoteTypeFilter value="noType" checked={props.type.noType} onClick={() => props.onTypeClick('noType')} />
            <MapNoteTypeFilter value="mapRequest" checked={props.type.mapRequest} onClick={() => props.onTypeClick('mapRequest')} />
            <MapNoteTypeFilter value="fieldVerify" checked={props.type.fieldVerify} onClick={() => props.onTypeClick('fieldVerify')} />
        </div>
    </div>
);

MapNoteFilterMenu.propTypes = {
    status: PropTypes.string.isRequired,
    type: PropTypes.objectOf(PropTypes.bool).isRequired,
    totals: PropTypes.objectOf(PropTypes.number).isRequired,
    onStatusClick: PropTypes.func.isRequired,
    onTypeClick: PropTypes.func.isRequired,
};

export default MapNoteFilterMenu;
